<template>
  <div>
    <!-- <v-footer :fixed="fixed" app> -->
      <span>
          <v-card >
            <v-bottom-nav
              :value="true"
              :active.sync="e2"
              :color="color"
              shift
              app
              dark
            >
            <router-link to="/schedule">
              <v-btn dark>
                <span>Agenda</span>
                <v-icon>event</v-icon>
              </v-btn>
            </router-link>
            <router-link to="/dashboard">
              <v-btn dark>
                <span>Dashboard</span>
                <v-icon>dashboard</v-icon>
              </v-btn>
            </router-link>
            <router-link to="/patient">
              <v-btn dark>
                <span>Paciente</span>
                <v-icon>account_circle</v-icon>
              </v-btn>
            </router-link>
            <router-link to="/proposed-surgeries" v-if="this.auth.auth.user.customer === '5f46a91567657c4ccd58f6a0' || env !== 'production'">
              <v-btn dark>
                <span>Centro Cirurgico</span>
                <v-icon>mdi-hospital-box</v-icon>
              </v-btn>
            </router-link>
            <!-- <router-link to="/proposed-surgeries" v-if="env !== 'production'">
              <v-btn dark>
                <span>Centro Cirurgico</span>
                <v-icon>mdi-hospital-box</v-icon>
              </v-btn>
            </router-link> -->
            <!-- <a target="_blank" :href="'https://memed.gestaoclinic.com.br/?token=' + getToken + '&idExterno=-99&idCustomer=' + auth.auth.user.codeCustomer + '&idReceituario=1&idDoctor=' + auth.auth.user.crm">
              <v-btn dark>
                <span>Memed-Receitas</span>
                <v-icon>description</v-icon>
                este aqui deixa comentado <a target="_blank" :href="'https://memed.gestaoclinic.com.br/?token=' + urlDataToken + '&idExterno=' + detailSchedule.code + '&idCustomer=' + auth.auth.user.codeCustomer + '&idReceituario=1&idDoctor=' + auth.auth.user.crm"></a>
              </v-btn>
            </a>

            este codigo abaixo comentar
            <router-link to="/graph">
              <v-btn dark>
                <span>Gráfico</span>
                <v-icon>bar_chart</v-icon>
              </v-btn>
            </router-link>
            <router-link to="/imagem">
              <v-btn dark>
                <span>Consultor Pessoal</span>
                <v-icon>score</v-icon>
              </v-btn>
            </router-link> -->
          </v-bottom-nav>
        </v-card>
      </span>

    <!-- </v-footer> -->

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    mounted () {
      this.env = process.env.NODE_ENV
    },
    components: {
    },
    data () {
      return {
        env: null,
        e2: 0,
        urlDataToken: null
      }
    },
    created () {
      this.urlDataToken = this.getToken
    },
    computed: {
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      ...mapGetters('app', ['getTheme', 'getDevice']),
      ...mapGetters('memed', ['getToken']),
      color () {
        switch (this.e2) {
          case 0: return this.getTheme.color
          case 1: return 'blue darken-1'
          case 2: return 'blue darken-3'
          case 3: return 'blue darken-4'
        }
      }
    },
    name: 'Footer'
  }
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue